module.exports = __webpack_public_path__ + "static/media/airport-muted.c021f500.svg";